import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d8741ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-4 px-lg-5 px-3" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = {
  class: "border-1 my-3 px-3",
  style: {"border":"1px solid grey"}
}
const _hoisted_4 = { class: "mt-3 box_container" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-12 mb-3" }
const _hoisted_9 = { class: "card card-body shadow" }
const _hoisted_10 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Monthly analysis of health needs", -1))
const _hoisted_12 = { class: "p-float-label prime_input w-50" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter",
  class: "overflow"
}, "MM/YYYY", -1))
const _hoisted_14 = { class: "col-lg-12 mb-3" }
const _hoisted_15 = { class: "card card-body shadow" }
const _hoisted_16 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Monthly analysis of health innovations", -1))
const _hoisted_18 = { class: "p-float-label prime_input w-50" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter",
  class: "overflow"
}, "MM/YYYY", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("section", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerData, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "bx text-center",
            key: i
          }, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(item.value), 1),
            _createElementVNode("p", null, _toDisplayString(item.title), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, [
                _createVNode(_component_Calendar, {
                  id: "filterNeeds",
                  name: "filterNeeds",
                  modelValue: _ctx.filterNeeds,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterNeeds) = $event)),
                  class: "h-50 w-100",
                  dateFormat: "mm/yy",
                  minDate: _ctx.minDate,
                  maxDate: _ctx.maxDate
                }, null, 8, ["modelValue", "minDate", "maxDate"]),
                _hoisted_13
              ])
            ]),
            _createVNode(_component_Chart, {
              type: "bar",
              data: _ctx.needsAnalytics,
              options: _ctx.option,
              height: 100
            }, null, 8, ["data", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("span", _hoisted_18, [
                _createVNode(_component_Calendar, {
                  id: "filterInnovations",
                  name: "filterInnovations",
                  modelValue: _ctx.filterInnovations,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterInnovations) = $event)),
                  class: "h-50 w-100",
                  numberOfMonths: 1,
                  minDate: _ctx.minDate,
                  maxDate: _ctx.maxDate,
                  dateFormat: "mm/yy"
                }, null, 8, ["modelValue", "minDate", "maxDate"]),
                _hoisted_19
              ])
            ]),
            _createVNode(_component_Chart, {
              type: "bar",
              data: _ctx.innovationAnalytics,
              options: _ctx.option,
              height: 100
            }, null, 8, ["data", "options"])
          ])
        ])
      ])
    ])
  ]))
}